import React from "react";

export default function TrHead() {
    const data = [
        "",
        "Person",
        "From",
        "To",
        "Total",
        "Leave type",
        "View",
        "Action"
    ];
    let list = [];
    for(const i in data) {
        list.push(<th key={"col-" + i} className={"th-" + data[i].toLocaleLowerCase()}>
            {data[i]}
        </th>);
    }
    return <tr key="row-0">
        {list}    
    </tr>
}